import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/nl/faq", "nl", "faq");
